<template>
    <div>
        <div class="mergejil " >
            <div class="row">
                <div class="col-md-12">
                    <h3 class="title">МЭРГЭЖИЛ САЛБАРААР</h3>
                </div>
            </div>
            <div class="row">
<!--                <div class="col-md-12">-->
<!--                    <Carousel v-model="value1" loop>-->
<!--                        <CarouselItem-->
<!--                                :autoplay="setting.autoplay"-->
<!--                                :autoplay-speed="setting.autoplaySpeed"-->
<!--                                :dots="setting.dots"-->
<!--                                :radius-dot="setting.radiusDot"-->
<!--                                :trigger="setting.trigger"-->
<!--                                :arrow="setting.arrow">-->
<!--                            <div class="slide">-->
<!--                                <div class="row">-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <a href="http://tvets.edu.mn/мэргэжлүүд" target="_blank">-->
<!--                                                    <img src="../../assets/item/bolovsrol.png">-->
<!--                                                    <h3>Боловсрол</h3>-->
<!--                                                    &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно. </p>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                                                <div class="mergejil-item-black">&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                                                    <h3>Боловсрол</h3>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                                                    <div class="right_but"><i class="fa fa-chevron-right"></i></div>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                                                    <img src="../../assets/item/back-icon1.png" alt="">&ndash;&gt;-->
<!--                                                    &lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--                                                </a>-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/urlag.png">-->
<!--                                                <h3>Соёл, урлаг</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/tsagdaa.png">-->
<!--                                                <h3>Цагдаа, батлан хамгаалах, онцгой байдал</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/sanhvv.png">-->
<!--                                                <h3>Санхүү, бизнес, худалдааны салбар</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/it.png">-->
<!--                                                <h3>Мэдээлэл технологи</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/shuudan.png">-->
<!--                                                <h3>Шуудан, харилцаа холбоо</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/orchin.png">-->
<!--                                                <h3>Байгаль орчин, аялал жуулчлал</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/barilga.png">-->
<!--                                                <h3>Барилга</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </CarouselItem>-->
<!--                        <CarouselItem>-->
<!--                            <div class="slide">-->
<!--                                <div class="row">-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/teever.png">-->
<!--                                                <h3>Тээвэр</h3>-->
<!--                                                &lt;!&ndash;                                        <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/erchim_hvch.png">-->
<!--                                                <h3>Эрчим хүч</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/uul_uurhai.png">-->
<!--                                                <h3>Уул уурхай</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/HAA.png">-->
<!--                                                <h3>Хөдөө аж ахуй</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/aj_vildver.png">-->
<!--                                                <h3>Аж үйлдвэр</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/tohijilt.png">-->
<!--                                                <h3>Хот байгуулалт, тохижилт</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/vilchilgee.png">-->
<!--                                                <h3>Үйлчилгээ</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <div class="col-6 col-md-3">-->
<!--                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">-->
<!--                                            <div class="mergejil-item">-->
<!--                                                <img src="../../assets/item/ervvl_mend.png">-->
<!--                                                <h3>Эрүүл мэнд</h3>-->
<!--                                                &lt;!&ndash;                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>&ndash;&gt;-->
<!--                                            </div>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </CarouselItem>-->

<!--                    </Carousel>-->
<!--                </div>-->

                    <swiper class="swiper" ref="swiper" :options="swiperOption1">
                        <swiper-slide>
                            <div class="slide">
                                <div class="row">
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <a href="http://tvets.edu.mn/мэргэжлүүд" target="_blank">
                                                    <img src="../../assets/item/bolovsrol.png">
                                                    <h3>Боловсрол</h3>
                                                    <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно. </p>-->
                                                    <!--                                                <div class="mergejil-item-black">-->
                                                    <!--                                                    <h3>Боловсрол</h3>-->
                                                    <!--                                                    <div class="right_but"><i class="fa fa-chevron-right"></i></div>-->
                                                    <!--                                                    <img src="../../assets/item/back-icon1.png" alt="">-->
                                                    <!--                                                </div>-->
                                                </a>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/urlag.png">
                                                <h3>Соёл, урлаг</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/tsagdaa.png">
                                                <h3>Цагдаа, батлан хамгаалах, онцгой байдал</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/sanhvv.png">
                                                <h3>Санхүү, бизнес, худалдааны салбар</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/it.png">
                                                <h3>Мэдээлэл технологи</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/shuudan.png">
                                                <h3>Шуудан, харилцаа холбоо</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/orchin.png">
                                                <h3>Байгаль орчин, аялал жуулчлал</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/barilga.png">
                                                <h3>Барилга</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide">
                                <div class="row">
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/teever.png">
                                                <h3>Тээвэр</h3>
                                                <!--                                        <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/erchim_hvch.png">
                                                <h3>Эрчим хүч</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/uul_uurhai.png">
                                                <h3>Уул уурхай</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/HAA.png">
                                                <h3>Хөдөө аж ахуй</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/aj_vildver.png">
                                                <h3>Аж үйлдвэр</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/tohijilt.png">
                                                <h3>Хот байгуулалт, тохижилт</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/vilchilgee.png">
                                                <h3>Үйлчилгээ</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <a href="http://chadamj.tvets.edu.mn/%D0%BC%D1%8D%D1%80%D0%B3%D1%8D%D0%B6%D0%BB%D2%AF%D2%AF%D0%B4" target="_blank">
                                            <div class="mergejil-item">
                                                <img src="../../assets/item/ervvl_mend.png">
                                                <h3>Эрүүл мэнд</h3>
                                                <!--                                            <p>Энэ нь хэвлэх эцсийн танилцуулга гажуудуулж болно.</p>-->
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev-1" slot="button-prev" @click="prev()">
                      <i class="fa fa-chevron-left"></i>
<!--                      <img src="../../assets/left-arrow.png" alt="">-->
                    </div>
                    <div class="swiper-button-next-1" slot="button-next" @click="next()">
                      <i class="fa fa-chevron-right"></i>
<!--                      <img src="../../assets/right-arrow.png" alt="">-->
                    </div>


            </div>
        </div>
    </div>
</template>
<script>
    import { Swiper, SwiperSlide, directive} from 'vue-awesome-swiper';
    import 'swiper/swiper-bundle.css';
    export default {
        name: 'home',
        components: {
            Swiper,
            SwiperSlide,
        },
        directives: {
            swiper: directive
        },
        data () {
            return {
                value1: 0,
                msg: 'Welcome to Your Vue.js App',
                swiperOption1: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next-1',
                        prevEl: '.swiper-button-prev-1'
                    },
                },
                // setting: {
                //     autoplay: false,
                //     autoplaySpeed: 2000,
                //     dots: 'inside',
                //     radiusDot: false,
                //     trigger: 'click',
                //     arrow: 'hover'
                // }
            }
        },
        methods: {
            prev() {
                this.$refs.swiper.$swiper.slidePrev();
            },
            next() {
                this.$refs.swiper.$swiper.slideNext();
            }
        },
        mounted(){

        }
    }
</script>
